import { render, staticRenderFns } from "./newbaseplan.vue?vue&type=template&id=239416b2&scoped=true&"
import script from "./newbaseplan.vue?vue&type=script&lang=js&"
export * from "./newbaseplan.vue?vue&type=script&lang=js&"
import style0 from "./newbaseplan.vue?vue&type=style&index=0&id=239416b2&prod&lang=scss&scoped=true&"
import style1 from "./newbaseplan.vue?vue&type=style&index=1&id=239416b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239416b2",
  null
  
)

export default component.exports